import * as React from 'react'

import Spinner from '../../components/Spinner'
import Icons from '../Icons'

function TableFooterButton({ isLoading, onClick, label, labelLoading }) {
  const [isRunning, setRunning] = React.useState(false)

  const clickCallback = React.useCallback(async () => {
    setRunning(true)
    !isLoading && (await onClick())
    setRunning(false)
  }, [isLoading, onClick])

  return (
    <div
      className="p-2 text-xs md:text-sm leading-5 font-medium text-txt hover:text-zentake space-x-2 bg-gray-50 cursor-pointer flex items-center justify-center"
      onClick={clickCallback}
    >
      {isRunning ? (
        <Spinner color="onLight" size={20} />
      ) : (
        <Icons.PlusCircle inheritColor />
      )}
      <span className={isRunning ? 'text-txt' : ''}>
        {isRunning ? labelLoading || label : label}
      </span>
    </div>
  )
}

export default TableFooterButton
